<div
  class="tax-return-list-item"
  [attr.data-test-ref]="'tax-return-list'"
  [ngClass]="{ inactive: !isActive() || !isTrActive() }"
  (mouseenter)="hover = true"
  (mouseleave)="hover = false"
>
  @if (taxReturn) { @if (showBulkAction) {
  <div class="bulk-checkbox">
    <div class="ui checkbox">
      <input
        type="checkbox"
        [(ngModel)]="selected"
        (change)="selectChanged.emit(selected)"
      /><label>&nbsp;</label>
    </div>
  </div>
  }
  <div
    class="phase-badge"
    [ngClass]="taxReturn.fullStatus.phase.id"
    [title]="taxReturn.fullStatus.phase.name"
  >
    <div class="badge-text">{{ taxReturn.fullStatus.phase.badge }}</div>
  </div>
  @if (oneTeamIntegrationEnabled && taxReturn.syncStatus && taxReturn.syncStatus
  > 0) {
  <div class="syncStatus">
    <span class="material-icons">cloud_off</span>
  </div>
  } @else { @if (oneTeamIntegrationEnabled) {
  <div>
    <span class="material-icons">cloud_done</span>
  </div>
  } }
  <div class="name" title="Name">
    <div class="taxpayer-name">{{ makeName(taxReturn) }}</div>
    @if (!isPopulationPage && !isClientTaxreturnsPage) {
    <div class="taxreturn-year">{{ taxReturn.year }}</div>
    }
  </div>
  <div class="atlas-id" [title]="uiConfig?.config?.atlasId">
    {{ taxReturn.atlasId }}
  </div>
  @if (assignee.populations) {
  <div class="client">
    <div class="client-name">{{ currentPopulation?.client?.name }}</div>
    <div class="population-name">{{ currentPopulation?.name }}</div>
  </div>
  } @if (showQnrType) {
  <div class="questionnaire-type" title="Questionnaire type">
    {{ questionnaireTypeName }}
  </div>
  } @if (showTaxReturnType) {
  <div class="taxreturn-type" title="{{ taxReturnAlias }} type/Subtype">
    <div class="tr-type">{{ taxReturn.taxReturnTypeName || "" }}</div>
    <div class="tr-subtype">{{ taxReturn.taxReturnSubTypeName || "" }}</div>
  </div>
  }
  <div
    class="assigned-user"
    [ngClass]="{ 'no-assigned-user': !taxReturn.assignedUser }"
    title="Assigned user"
  >
    @if (taxReturn.assignedUser) {
    {{ taxReturn.assignedUser.name }}
    } @if (!taxReturn.assignedUser && ( taxReturn.fullStatus.step.id ===
    'pre-preparation')) {
    {{ "no-pre-preparer-assigned" | transloco }}
    } @if (!taxReturn.assignedUser && ( taxReturn.fullStatus.step.id ===
    'preparation' || taxReturn.fullStatus.step.id === 'prep-package-generating'
    || taxReturn.fullStatus.step.id === 'prep-package-generated')) {
    {{ "no-preparer-assigned" | transloco }}
    } @if (!taxReturn.assignedUser && ( taxReturn.fullStatus.step.id ===
    'first-review' || taxReturn.fullStatus.step.id ===
    'first-review-package-generating' || taxReturn.fullStatus.step.id ===
    'first-review-package-generated' || taxReturn.fullStatus.step.id ===
    'second-review' || taxReturn.fullStatus.step.id ===
    'second-review-package-generating' || taxReturn.fullStatus.step.id ===
    'second-review-package-generated')) {
    {{ "no-reviewer-assigned" | transloco }}
    }
  </div>
  <div class="status">
    <app-status-badge
      [status]="taxReturn.fullStatus"
      [complexity]="taxReturn.statusComplexity"
    ></app-status-badge>
  </div>
  <div
    class="ui search selection dropdown"
    #preparerType
    [hidden]="!showProjectStatusOptions"
    [ngClass]="{
      disabled:
        !enableProjectStatusOptions.includes(this.taxReturn.status) &&
        !enableAmendedProjectStatusOptions.includes(this.taxReturn.status)
    }"
  >
    <i class="chevron down icon"></i>
    <div class="text"></div>
    <div class="menu"></div>
  </div>
  <div class="action">
    @if (isActive() && isTrActive() && taxReturn.fullStatus.id !== 200 ) { @for
    (action of taxReturn.fullStatus.step.listActions(config); track action) {
    <button
      [attr.data-test-ref]="'action'"
      class="action-button {{ action.id }} list-action"
      [hidden]="
        action.hasUserRestriction &&
        action.hasUserRestriction(config, userInfo, taxReturn)
      "
      [ngClass]="{
        'semi-disabled': !!taxReturn.assignedUser,
        'disabled-action-button':
          disableActionButton ||
          (disableStartProcess &&
            (action.name === 'Start Process' ||
              action.name === 'Check for Prefill'))
      }"
      [title]="action.title || action.name || ''"
      (click)="doAction(action)"
      [disabled]="disableActionButton"
    >
      {{ action.name }}
    </button>
    } } @if (!isActive()) {
    <div class="action-button deactivated">{{ "deactivated" | transloco }}</div>
    }
  </div>
  }

  <div
    [attr.data-test-ref]="'ellipsis'"
    [matMenuTriggerFor]="popupTemplate"
    class="icon"
    [ngClass]="{ 'grey-ellipsis': !hover, 'blue-ellipsis': hover }"
  ></div>

  <mat-menu #popupTemplate yPosition="above">
    <div
      class="menu"
      [ngClass]="{ wide: canDeleteData, default: !canDeleteData }"
    >
      @if (taxReturn && checkCountryAccess()) {
      <div
        [routerLink]="[
          '/',
          uiConfig?.config?.taxReturnAliasPath,
          taxReturn?.id
        ]"
        class="item"
      >
        {{ "view" | transloco }}
      </div>
      } @if (!taxReturn && checkCountryAccess()) {
      <div class="item disabled">{{ "view" | transloco }}</div>
      }
      <!--<div class="item disabled">Edit</div>-->
      @if (canMovePopulation) {
      <div (click)="moveTaxpayer()" class="item">{{ "move" | transloco }}</div>
      } @if (!isEss && checkCountryAccess()) {
      <div
        (click)="canAddSpouse(assignee) && addSpouse()"
        class="item"
        [ngClass]="{ disabled: !canAddSpouse(assignee) }"
        [attr.data-test-ref]="'addSpouse'"
      >
        {{ "add-spouse" | transloco }}
      </div>
      } @if (checkCountryAccess()) {
      <div (click)="toggleStatus()" class="item toggle-status">
        {{ isActive() ? "Deactivate" : "Activate" }}
      </div>
      }
      <div (click)="viewInfo()" class="item" [attr.data-test-ref]="'info'">
        {{ "info" | transloco }}
      </div>
      @if (checkCountryAccess()) {
      <div (click)="viewNotes()" class="item">Notes</div>
      }
      <!-- TRANSLOCO TODO -->
      @if (config.featureFlags.closeTaxReturn) {
      <div
        (click)="toggleTrStatus()"
        class="item"
        [ngClass]="{ disabled: !isActive() }"
      >
        {{ isTrActive() ? "Close" : "Re-open" }} {{ taxReturnAlias }}
      </div>
      }
      <!-- END OF TRANSLOCO TODO -->
      @if (canDeleteData) {
      <div
        (click)="confirmDelete('TR')"
        [ngClass]="{ disabled: !canDeleteData }"
      >
        {{ "permanently-delete" | transloco }} {{ taxReturnAlias }}
      </div>
      } @if (canDeleteData) {
      <div
        (click)="confirmDelete('TP')"
        [ngClass]="{ disabled: !canDeleteData }"
      >
        {{ "permanently-delete" | transloco }} {{ taxpayerAlias }}
      </div>
      }
      <!-- TRANSLOCO TODO -->
      @if (canDeleteData) {
      <div
        (click)="confirmDelete('TRA')"
        [ngClass]="{ disabled: !canDeleteData }"
      >
        Permanently Delete All Answers
      </div>
      }
      <!-- END OF TRANSLOCO TODO -->
      @if (showResubmitOrChangeBtn && isTaxReturnLodged()) {
      <div (click)="backToResubmit()" class="item">
        {{ "back-to-resubmit" | transloco }}
      </div>
      } @if (showResubmitOrChangeBtn && !isTaxReturnLodged()) {
      <div class="item disabled">{{ "back-to-resubmit" | transloco }}</div>
      } @if (showResubmitOrChangeBtn && isTaxReturnLodged()) {
      <div (click)="backForChanges()" class="item">
        {{ "back-for-changes" | transloco }}
      </div>
      } @if (showResubmitOrChangeBtn && !isTaxReturnLodged()) {
      <div class="item disabled">{{ "back-for-changes" | transloco }}</div>
      }
    </div>
  </mat-menu>

  <div
    #confirmCloseTaxReturn
    id="confirm-close-tax-return"
    class="ui tiny modal"
  >
    <div class="icon modal-close close"></div>
    <h1>Close {{ taxReturnAlias }}</h1>

    <div class="content">
      Are you sure you want to close {{ taxReturnAlias }} of id#{{
        taxReturn?.id
      }}
      for <b>{{ taxReturn?.firstName }} {{ taxReturn?.lastName }}</b
      >?
      <br />
      <br />
      <strong>Reason:</strong>
      <div class="row">
        <div class="column">
          <textarea
            style="resize:none; width: 100%; height: 80px"
            [(ngModel)]="closedReason"
            name="body"
          ></textarea>
        </div>
      </div>
    </div>

    <div class="actions">
      <span class="go-back cancel">Cancel</span>
      <button
        [ngClass]="{ disabled: !(closedReason && closedReason.length > 0) }"
        class="ui primary background approve button"
      >
        Close {{ taxReturnAlias }}
      </button>
    </div>
  </div>

  <div #confirmOpenTaxReturn id="confirm-open-tax-return" class="ui tiny modal">
    <div class="icon modal-close close"></div>
    <h1>Open {{ taxReturnAlias }}</h1>

    <div class="content">
      Are you sure you want to open {{ taxReturnAlias }} of id#{{
        taxReturn?.id
      }}
      for <b>{{ taxReturn?.firstName }} {{ taxReturn?.lastName }}</b
      >?
      <br />
      <br />
      <strong
        >{{ taxReturnAlias }} has been closed for the following reason:</strong
      >
      <div class="row">
        <div class="column">
          <blockquote>
            <q>{{ closedReason }}</q>
          </blockquote>
        </div>
      </div>
    </div>

    <div class="actions">
      <span class="go-back cancel">Cancel</span>
      <button class="ui primary background approve button">
        Open {{ taxReturnAlias }}
      </button>
    </div>
  </div>

  <div
    #confirmDeleteTaxReturn
    id="confirm-delete-tax-return"
    class="ui tiny modal"
  >
    <div class="icon modal-close close"></div>

    <h1>{{ "are-you-sure" | transloco }}</h1>

    <div class="content">
      Are you sure you want to permanently delete all information associated
      with {{ taxReturnAlias }} id#{{ taxReturn?.id }} for
      <b>{{ taxReturn?.firstName }} {{ taxReturn?.lastName }}</b
      >? Note that this action cannot be undone.
      <br />
      <br />
      <strong>This can sometimes take up to 10-20 minutes.</strong>
    </div>

    <div class="ui checkbox">
      <input type="checkbox" name="snoozeWarning" [(ngModel)]="snoozeWarning" />
      <label>Do not warn me again for the next 10 minutes.</label>
    </div>

    <div class="actions">
      <span class="go-back cancel">Cancel</span>
      <button class="ui primary background approve button">Yes, Delete</button>
    </div>
  </div>
  <div
    #confirmDeleteAllAnswers
    id="confirm-delete-all-tax-return-answers"
    class="ui tiny modal"
  >
    <div class="icon modal-close close"></div>

    <h1>Are you sure?</h1>

    <div class="content">
      Are you sure you want to permanently delete all answers associated with
      tax return id#{{ taxReturn?.id }} for
      <b>{{ taxReturn?.firstName }} {{ taxReturn?.lastName }}</b
      >? Note that this action cannot be undone.
      <br />
      <br />
      <strong>This can sometimes take up to 10-20 minutes.</strong>
    </div>

    <div class="ui checkbox">
      <input type="checkbox" name="snoozeWarning" [(ngModel)]="snoozeWarning" />
      <label>{{
        "do-not-warn-me-again-for-the-next-10-minutes" | transloco
      }}</label>
    </div>

    <div class="actions">
      <span class="go-back cancel">{{ "cancel" | transloco }}</span>
      <button class="ui primary background approve button">
        {{ "yes-delete" | transloco }}
      </button>
    </div>
  </div>

  <div
    #confirmDeleteTaxpayer
    id="confirm-delete-taxpayer"
    class="ui tiny modal"
  >
    <div class="icon modal-close close"></div>

    <h1>{{ "are-you-sure" | transloco }}</h1>

    <div class="content">
      Are you sure you want to permanently delete all information associated
      with {{ taxpayerAlias }}
      <b>{{ assignee?.firstName }} {{ assignee?.lastName }}</b
      >, including all of their {{ taxReturnAlias }}s? Note that this action
      cannot be undone.
    </div>

    <div class="ui checkbox">
      <input type="checkbox" name="snoozeWarning" [(ngModel)]="snoozeWarning" />
      <label>{{
        "do-not-warn-me-again-for-the-next-10-minutes" | transloco
      }}</label>
    </div>

    <div class="actions">
      <span class="go-back cancel">{{ "cancel" | transloco }}</span>
      <button class="ui primary background approve button">
        {{ "yes-delete" | transloco }}
      </button>
    </div>
  </div>
</div>
